import { n as i } from "./abstract-base-CdeHT0x1.js";
import { p as u, d as B, m } from "./lifecycle-decorators-VlFt_asj.js";
var a = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = (p, e, r, t) => {
  for (var s = t > 1 ? void 0 : t ? c(e, r) : e, n = p.length - 1, o; n >= 0; n--)
    (o = p[n]) && (s = (t ? o(e, r, s) : o(s)) || s);
  return t && s && a(e, r, s), s;
};
function h(p) {
  let e = class extends p {
    constructor() {
      super(...arguments), this.opensBy = "";
    }
    get opensByElements() {
      if (this.opensBy) {
        const r = this.opensBy.split(" "), t = /* @__PURE__ */ new Map();
        return r.forEach((s) => {
          const n = this.getClosestHost();
          n ? Array.from(
            n.shadowRoot.querySelectorAll(s)
          ).forEach(
            (y) => t.set(y, !0)
          ) : Array.from(document.querySelectorAll(s)).forEach(
            (y) => t.set(y, !0)
          );
        }), t;
      }
    }
    /** @abstract */
    runOpensBySetup() {
    }
    /** @abstract */
    runOpensByClean() {
    }
    setupOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensBySetup();
    }
    cleanOpensByElements() {
      this.opensByElements && this.opensByElements.size > 0 && this.runOpensByClean();
    }
    /**
     * Public-facing API method to refresh opens-by elements.
     * Some apps do not have control over the order of loading the trigger element vs. the popover.
     * This allows discovery of trigger elements after page load.
     */
    refreshOpensByElements() {
      this.cleanOpensByElements(), this.setupOpensByElements();
    }
  };
  return l([
    i({ attribute: "opens-by" })
  ], e.prototype, "opensBy", 2), l([
    u
  ], e.prototype, "setupOpensByElements", 1), l([
    B
  ], e.prototype, "cleanOpensByElements", 1), e = l([
    m("OpensBy")
  ], e), e;
}
export {
  h as O
};
